// ---- Action types ----
export const CHANGE_ACTIVE_TS_EXPERT = "CH_TS_EXPERT";
export const CHANGE_ACTIVE_ITEM_LIVELIST = "CH_LL";
export const CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX = "CH_LL_MATRIX";
export const CHANGE_ACTIVE_ITEM_OSCILLOSCOPE = "CH_OSCILLOSCOPE";
export const CHANGE_ACTIVE_ITEM_BAR_GRAPH = "CH_BARGRAPH";
export const CHANGE_ACTIVE_ITEM_OPTIC_FIBER = "CH_OPTIC";
export const CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG = "CH_OPTIC_LOG";
export const CHANGE_ACTIVE_ITEM_LOG = "CH_LOG";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";
